"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExplorerFolderType = void 0;
var ExplorerFolderType;
(function (ExplorerFolderType) {
    ExplorerFolderType[ExplorerFolderType["Default"] = 0] = "Default";
    ExplorerFolderType[ExplorerFolderType["Form"] = 1] = "Form";
    ExplorerFolderType[ExplorerFolderType["Flow"] = 2] = "Flow";
    ExplorerFolderType[ExplorerFolderType["Asset"] = 3] = "Asset";
    ExplorerFolderType[ExplorerFolderType["Bin"] = 4] = "Bin";
    ExplorerFolderType[ExplorerFolderType["Reference"] = 5] = "Reference";
    ExplorerFolderType[ExplorerFolderType["Library"] = 6] = "Library";
    ExplorerFolderType[ExplorerFolderType["Client"] = 7] = "Client";
    ExplorerFolderType[ExplorerFolderType["Server"] = 8] = "Server";
    ExplorerFolderType[ExplorerFolderType["Entity"] = 9] = "Entity";
    ExplorerFolderType[ExplorerFolderType["Forms"] = 10] = "Forms";
    ExplorerFolderType[ExplorerFolderType["Flows"] = 11] = "Flows";
    ExplorerFolderType[ExplorerFolderType["Dist"] = 12] = "Dist";
    ExplorerFolderType[ExplorerFolderType["SuitForm"] = 13] = "SuitForm";
    ExplorerFolderType[ExplorerFolderType["Analytics"] = 14] = "Analytics";
    ExplorerFolderType[ExplorerFolderType["DataSource"] = 15] = "DataSource";
    ExplorerFolderType[ExplorerFolderType["Scheduler"] = 16] = "Scheduler";
    ExplorerFolderType[ExplorerFolderType["Reports"] = 17] = "Reports";
    ExplorerFolderType[ExplorerFolderType["Action"] = 18] = "Action";
})(ExplorerFolderType || (exports.ExplorerFolderType = ExplorerFolderType = {}));
exports.default = ExplorerFolderType;
//# sourceMappingURL=ExplorerFolderType.js.map